import { useState } from "react";
import { Upload, Loader2, FileCheck2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/apiClient";
import { Checkbox } from "@/components/ui/checkbox";

const Check = ({ k, label, q, set, tone }) => (
  <label className={`flex items-center gap-3 rounded-lg border px-3 py-2 text-sm ${tone || "border-border/60"}`}>
    <Checkbox data-testid={`do-q-${k}`} checked={!!q[k]} onCheckedChange={(v) => set({ ...q, [k]: !!v })} />
    <span className="text-forest">{label}</span>
  </label>
);

// Questionario D&O (Mod. 20E): requisiti, adeguati assetti (indice di rischio) e informazioni per la Direzione.
export const DoQuestionario = ({ config, ente, q, set }) => (
  <div className="space-y-4" data-testid="do-questionario">
    {ente === "cooperativa" && <Check k="confcooperative" label="La cooperativa aderisce a Confcooperative" q={q} set={set} />}
    <div className="space-y-2">
      <div className="text-xs font-semibold uppercase tracking-wide text-red-700">Casi non assicurabili</div>
      {Object.entries(config.blocchi).map(([k, l]) => <Check key={k} k={k} label={l} q={q} set={set} />)}
    </div>
    <div className="space-y-2">
      <div className="text-xs font-semibold uppercase tracking-wide text-forest">Adeguati assetti organizzativi, amministrativi e contabili</div>
      <label className="flex items-center gap-3 rounded-lg border border-border/60 px-3 py-2 text-sm">
        <Checkbox data-testid="do-q-assetti_adeguati" checked={q.assetti_adeguati !== false} onCheckedChange={(v) => set({ ...q, assetti_adeguati: !!v })} />
        <span className="text-forest">L'ente ha istituito adeguati assetti come previsto dal Codice della crisi d'impresa</span>
      </label>
      {Object.entries(config.segnali).map(([k, l]) => <Check key={k} k={k} label={l} q={q} set={set} />)}
      <p className="text-[11px] text-muted-foreground">Nessun segnale: rischio basso. Un segnale: medio (+5%). Due o più: alto (+15%).</p>
    </div>
    <div className="space-y-2">
      <div className="text-xs font-semibold uppercase tracking-wide text-forest">Informazioni per la Direzione</div>
      {Object.entries(config.allerte).map(([k, l]) => <Check key={k} k={k} label={l} q={q} set={set} />)}
    </div>
  </div>
);

// Caricamento dei documenti obbligatori per la quotazione della Direzione Tecnica.
export const DoDocumenti = ({ config, docs, setDocs, ente }) => {
  const [busy, setBusy] = useState("");
  const upload = async (tipo, file) => {
    if (!file) return;
    setBusy(tipo);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("tipo", `do_${tipo}`);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setDocs((ds) => [...ds, { tipo, id: data.id, storage_path: data.storage_path, nome: data.original_filename }]);
      toast.success("Documento caricato");
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(""); }
  };
  return (
    <div className="space-y-2" data-testid="do-documenti">
      {Object.entries(config.documenti).filter(([k]) => k !== "rendiconto_ets" || ente === "ets").map(([k, l]) => {
        const mine = docs.filter((d) => d.tipo === k);
        return (
          <div key={k} className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-border/60 px-3 py-2 text-sm">
            <div className="min-w-0">
              <div className="text-forest">{l}</div>
              {mine.map((d) => <div key={d.id} className="flex items-center gap-1 text-xs text-emerald-700"><FileCheck2 className="h-3.5 w-3.5" />{d.nome}</div>)}
            </div>
            <label className="inline-flex cursor-pointer items-center gap-1 rounded-full border border-forest/30 px-3 py-1 text-xs font-semibold text-forest hover:bg-sage">
              {busy === k ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Upload className="h-3.5 w-3.5" />}Carica
              <input type="file" className="hidden" accept=".pdf,.jpg,.jpeg,.png" data-testid={`do-doc-${k}`} onChange={(e) => upload(k, e.target.files?.[0])} />
            </label>
          </div>
        );
      })}
    </div>
  );
};
